import { Action } from '@ngrx/store';

export const INITIALIZE_COMPANY_FEATURE = '[Company] Initialize Feature';

export class InitializeCompanyFeature implements Action {
  readonly type = INITIALIZE_COMPANY_FEATURE;
}

export type InitializeFeatureActions = InitializeCompanyFeature;
